module.exports = "/images/selectedIcon.svg?859548b0fbcf411ec133e6ec31e69627";